import React, { useEffect, useState } from 'react';
import OlcButton from '~/components/General/OlcButton';

// Hooks
import { useDispatch } from 'react-redux';
import { isAdmin } from '~/hooks/permissions';

// Actions
import { getTeamMembersData } from '~/redux/actions/user-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Component
import InviteModal from './InviteModal';
import UserTable from './UserTable';
import LimitReach from '~/components/General/LimitModal';

// MUI Components
import { Box, Typography, GlobalStyles } from '@mui/material';

// Icons
import { GeneralInviteCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const User = () => {
  const [inviteModal, setinviteModal] = useState(false);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [initialLoad, setInitialLoad] = useState(true);
  const [limitModal, setLimitModal] = useState(false);
  const [limitMessage, setLimitMessage] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    let payload = {
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    dispatch(getTeamMembersData(payload)).finally(() => {
      setInitialLoad(false);
    });
  }, [pagination.page, pagination.pageSize]);

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#f9fafb' } }} />
      <Box className="olcWrapper">
        <Box className="olcScreenCard">
          <Box className="olcHeaderWrap">
            <Box>
              <Typography className="pageTitle">{MESSAGES.ACCOUNT.USERS.PAGE_TITLE}</Typography>
            </Box>
            {isAdmin() && (
              <Box className="pageNewBtn">
                <OlcButton
                  variant="primary"
                  onClick={() => setinviteModal(true)}
                  startIcon={<img src={GeneralInviteCIcon} alt="invite" />}
                >
                  <Typography>{MESSAGES.ACCOUNT.USERS.INVITE_BTN_TEXT}</Typography>
                </OlcButton>
              </Box>
            )}
          </Box>
          <UserTable
            pagination={pagination}
            updatePagination={setPagination}
            initialLoad={initialLoad}
          />
          <InviteModal
            openModal={inviteModal}
            handleCloseModal={() => setinviteModal(false)}
            updatePagination={setPagination}
            pagination={pagination}
            onLimitReached={(message) => {
              setinviteModal(false);
              setLimitMessage(message);
              setLimitModal(true);
            }}
          />
          <LimitReach
            open={limitModal}
            onClose={() => {
              setLimitModal(false);
              setTimeout(() => setLimitMessage(''), 100);
            }}
            message={limitMessage}
            resourceType="users"
          />
        </Box>
      </Box>
    </>
  );
};

export default User;
